import { render, staticRenderFns } from "./PlatformHelp.vue?vue&type=template&id=621a4d26&scoped=true&"
import script from "./PlatformHelp.vue?vue&type=script&lang=js&"
export * from "./PlatformHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a4d26",
  null
  
)

export default component.exports